module.exports = __webpack_public_path__ + "static/assets/9436ac5aad8fa1655ebbdd7f069b7b3a.png";